import Image from "next/image";
import Slider from "@/components/Atoms/Slider";
import { sendGTMEvent } from "@next/third-parties/google";
import { ArrowLeft, RightPink } from "@/public/Theme";

const CustomNextArrow = (props) => {
    const { onClick } = props;
    return (
        <div
            className="absolute right-2 top-1/2 z-10 transform -translate-y-1/2 cursor-pointer"
            onClick={onClick}
        >
            <Image
                src={RightPink}
                height={10}
                width={10}
                alt="Next"
                className="w-6 h-6"
            />
        </div>
    );
};

const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div
            className="absolute left-2 top-1/2 z-10 transform -translate-y-1/2 cursor-pointer"
            onClick={onClick}
        >
            <Image
                width={10}
                height={10}
                src={ArrowLeft}
                alt="Previous"
                className="w-6 h-6"
            />
        </div>
    );
};

const ProductCarousel = ({
    imagesCollection,
    productName,
    showCarousel,
    isMobile = false,
}) => {
    const settings = {
        arrows: true,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 2000,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
    };

    return (
        <>
            {showCarousel && imagesCollection?.length > 1 ? (
                <Slider
                    className="custom-slider-product"
                    // className="relative custom-slider-product overflow-hidden min-h-[300px] max-h-[300px]"
                    {...settings}
                    afterChange={() => {
                        sendGTMEvent({
                            event: "ImageInteractions",
                            interaction_type: "Image Swiped",
                            interaction_item: `Product Card: ${productName}`,
                        });
                    }}
                >
                    {imagesCollection?.map((image, index) => (
                        <div
                            className="relative min-h-[300px] lg:min-h-[300px] max-h-[300px] lg:max-h-[300px]"
                            key={index}
                        >
                            <Image
                                priority={index === 0}
                                quality={75}
                                src={
                                    image?.node?.url ||
                                    image?.url ||
                                    image?.url_zoom
                                }
                                alt={productName}
                                fill
                                sizes="(max-width:768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                className="w-full h-auto object-contain"
                                loading={index === 0 ? "eager" : "lazy"}
                            />
                        </div>
                    ))}
                </Slider>
            ) : (
                <div
                    className={`relative ${isMobile ? "min-h-[200px]" : "min-h-[300px] lg:min-h-[300px] max-h-[300px] lg:max-h-[300px]"}`}
                >
                    <Image
                        priority
                        quality={80}
                        src={
                            imagesCollection?.[0]?.node?.url ||
                            imagesCollection?.[0]?.url ||
                            imagesCollection?.[0]?.url_zoom
                        }
                        alt={productName}
                        fill
                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                        className="object-contain"
                    />
                </div>
            )}
        </>
    );
};
export default ProductCarousel;
